import { HTTP_WITHOUT_HEADER, HTTP } from '../../utils'
import { getItem } from '../../storage'

export const postUserLogin = (userInfo) => {
  let loginUrl = 'user/login'
  if (userInfo.institutionId) {
    loginUrl += '/' + userInfo.institutionId
  }
  return HTTP_WITHOUT_HEADER().post(loginUrl, userInfo)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const getSSOConfiguration = () => {
  return HTTP_WITHOUT_HEADER().get('configuration/prelogin/sso_configuration')
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const getEnvironment = () => {
  return HTTP_WITHOUT_HEADER().get('configuration')
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const getUserInfo = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('user/info')
    .then(response => {
      let data = response.data
      data.password = token
      return data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const saveUser = (uuid, user) => {
  return getItem('token').then(token => {
    return HTTP(token).put('/user/' + uuid, user)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const updatePassword = (data) => {
  return getItem('token').then(token => {
    return HTTP(token).post('/user/updatePassword', data)
    .then(res => {
      return res
    })
    .catch(e => {
      console.log(e)
      let res = {
        status: 400
      }
      return res
    })
  })
}

export const postSaveDataOptOut = (data) => {
  return getItem('token').then(token => {
    return HTTP(token).post('/user/dataOptOut', data)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
      let res = {
        status: 400
      }
      return res.data
    })
  })
}

export const populateUserJwt = (data) => {
  return getItem('token').then(token => {
    return HTTP(token).post('/user/login/jwt', {})
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const resetPassword = (email) => {
  return HTTP_WITHOUT_HEADER().get('user/resetPassword/' + email)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const verifyUser = (data) => {
  return HTTP_WITHOUT_HEADER().post('user/verify', data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const learnerSelfRegistration = (orgId, user) => {
  return HTTP_WITHOUT_HEADER().put('/user/learnerSelfRegistration/' + orgId, user)
  .then(res => {
    return res.data
  })
  .catch(e => {
    return e.response
  })
}

export const verifySelfRegistration = (data) => {
  return HTTP_WITHOUT_HEADER().post('user/verifySelfRegistration', data)
  .then(response => {
    return response
  })
  .catch(e => {
    return e.response
  })
}

export const getAllUserInstitution = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('/user/all/institution')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}

export const getChangeUserInstitution = (institutionId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/user/change/institution/' + institutionId)
    .then(res => {
      return res
    })
    .catch(e => {
      console.log('Error:' + e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/login/api.js